export default {
  welcome: 'Welcome To TraceHub'
}
